import * as E from "../../either";
import * as RNEA from "fp-ts/ReadonlyNonEmptyArray";
import { fromValidate, validate } from "../validated";
import { validationException, validationExceptionMany, } from "../validation-exception";
/**
 * Validator for validating to an Array with ALL items to a specific type.
 * Will validate all items before returning the validation exceptions.
 */
export const arrayAll = (t) => fromValidate((xs) => Array.isArray(xs)
    ? E.first((exceptions) => validationExceptionMany("Array validation failed", exceptions), xs.reduce(
    // TODO: Reimplement using traversable
    (e, x) => E.ap(E.map((elems) => (val) => elems.concat([val]), e), E.first((exception) => RNEA.of(validationException("Expected array element to be valid.", exception)), validate(t, x))), E.right([])))
    : E.left(validationException(`Expected value to be an Array, it has type ${typeof xs}.`)));
/**
 * Validator for validating to an Array with ALL items to a specific type.
 * Will validate until the first validation exception appears. Faster than `arrayAll`
 * but will not contain every error in the validation exception
 */
export const array = (t) => fromValidate((xs) => {
    if (Array.isArray(xs)) {
        const length = xs.length;
        let result = E.right([]);
        for (let i = 0; i < length; i++) {
            // validate the array item
            const val = validate(t, xs[i]);
            // If validation failed, return with immediately with validation error
            if (E.is.Left(val)) {
                return E.first((exception) => validationException("Expected array element to be valid.", exception), val);
            }
            // If validated, concat the validated value and continue
            else {
                result = E.ap(E.map((elems) => (val) => elems.concat([val]), result), val);
            }
        }
        return result;
    }
    else {
        return E.left(validationException(`Expected value to be an Array, it has type ${typeof xs}.`));
    }
});
export const isArray = fromValidate((xs) => Array.isArray(xs)
    ? E.of(xs)
    : E.left(validationException(`Expected value to be an Array, it has type ${typeof xs}.`)));

